import React from "react";
import { matchPath, Redirect, Route } from "react-router-dom";
import LoginRedirect from "../components/common/IdpRedirect/LoginRedirect";
import { roleName, tenantServicesMap } from "../constants/componentConstants";
import { ROUTES } from "../constants/routesConstants";
import { directLoginStorage, localStorageHelper } from "../utils/storageHelper";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  //Setting auth status true till we get auth API
  const authStatus = localStorageHelper.get("accessToken") || localStorageHelper.get("wsmAccessToken") ? true : false;
  const roleList = JSON.parse(localStorageHelper.get("role_name"));
  const isWorkspaceOnlylogin =
    (JSON.parse(localStorageHelper.get("tenant_services")) === tenantServicesMap?.both &&
      !JSON.parse(localStorageHelper.get("is_portal_login"))) ||
    (JSON.parse(localStorageHelper.get("tenant_services")) === tenantServicesMap?.workspaceLogin &&
      !JSON.parse(localStorageHelper.get("is_portal_login")));

  const isPooledVmConnectRedirect = (props) => {
    if (rest.path !== ROUTES.VM_CONNECT) {
      return <Redirect to={{ pathname: ROUTES.VM_CONNECT }} />;
    } else {
      return <Component {...props} />;
    }
  };

  const routeMaps = (props) => {
    if (directLoginStorage.get("isDemandLogin")) {
      return isPooledVmConnectRedirect(props);
    } else if (authStatus) {
      if (
        isWorkspaceOnlylogin &&
        ![
          ROUTES.USER_WORKSPACE,
          `${ROUTES.USER_MACHINE_CATALOG}${ROUTES.CREDIT_BASED_LAB_DETAILS}/:id`,
          `${ROUTES.MANAGE_VM}/:id`,
          `${ROUTES.MY_LABS}/:id`,
          `${ROUTES.PROFILE}/:id`,
        ].includes(rest.path)
      ) {
        return <Redirect to={{ pathname: ROUTES.USER_WORKSPACE }} />;
      } else if (!isWorkspaceOnlylogin && rest.path === ROUTES.USER_WORKSPACE) {
        return <Redirect to={{ pathname: "/pageNotFound" }} />;
      }
      if (rest.path?.includes("/userMachineCatalog/")) {
        const match = matchPath(`/*${ROUTES?.USER_MACHINE_CATALOG}/:id`, {
          path: rest.path,
          exact: true,
          strict: false,
        });
        if (match?.isExact) {
          return <Redirect to={`${ROUTES.USER_MACHINE_CATALOG}/${rest.computedMatch.params.id}`} />;
        }
        return <Component {...props} />;
      }
      if (rest.path?.includes("/userMachineCatalog")) {
        const match = matchPath(`/*${ROUTES?.USER_MACHINE_CATALOG}/`, {
          path: rest.path,
          exact: true,
          strict: false,
        });
        if (match?.isExact) {
          return <Redirect to={`${ROUTES.USER_MACHINE_CATALOG}`} />;
        }
        return <Component {...props} />;
      }
      if (
        roleList?.[0] === roleName.tenantadmin &&
        JSON.parse(localStorageHelper.get("tenant_services")) === tenantServicesMap?.portalLogin &&
        rest.path === ROUTES.WORKSPACE_MANAGER
      ) {
        return <Redirect to={{ pathname: "/pageNotFound" }} />;
      }
      return <Component {...props} />;
    } else {
      return <LoginRedirect />;
      // return <Route exact path={`${props?.location?.pathname}`} component={LoginRedirect} />;
    }
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        return routeMaps(props);
      }}
    />
  );
};

export default ProtectedRoute;
